import { queryClient } from '@hotjar/webapp/utils/react-query';

import * as insightsApi from '../domains/api';

type ApiFunction = typeof insightsApi.addCustomLabel;
type ApiResponseType = Awaited<ReturnType<ApiFunction>>;

export function useCreateLabel(siteId: number): {
  createLabel: (name: string) => Promise<ApiResponseType | null>;
} {
  const create = async (name: string) => {
    try {
      const newLabel = await insightsApi.addCustomLabel(siteId, name);
      queryClient.invalidateQueries([insightsApi.AVAILABLE_LABELS_QUERY_KEY]);
      queryClient.invalidateQueries([insightsApi.AVAILABLE_LABELS_QUERY_KEY, siteId]);
      return newLabel;
    } catch (err) {
      return null;
    }
  };

  return {
    createLabel: create,
  };
}
